// 管理者一覧チェックボックスリクエスト項目
export class CompanyManagementListRequest {
    constructor(MngSystemAdminFlag = false, MngServiceAdminFlag = false, MngHealthStaffFlag = false, MngIncidentReportFlag = false, MngCrisisReportFlag = false) {
        this.MngSystemAdminFlag = MngSystemAdminFlag;
        this.MngServiceAdminFlag = MngServiceAdminFlag;
        this.MngHealthStaffFlag = MngHealthStaffFlag;
        this.MngIncidentReportFlag = MngIncidentReportFlag;
        this.MngCrisisReportFlag = MngCrisisReportFlag;
    }
}
// 管理者詳細リクエスト項目
export class CompanyManagementDetailRequest {
    constructor(
        UserPk = '',
        UserId = '',
        MailAddress = '',
        IniPwdType = '1',
        IniPwdFree = '',
        NameKjLs = '',
        NameKjFs = '',
        NameKnLs = '',
        NameKnFs = '',
        CliFlag = true,
        RegistMethod = '',
        AuthenticateMethod = '',
        LastLoginDt = '',
        SuspendFlag = false,
        UseStartDate = '',
        UseEndDate = '',
        MngSystemAdminFlag = false,
        MngServiceAdminFlag = false,
        MngHealthStaffFlag = false,
        MngHealthStaffOrgAll = false,
        MngHealthStaffOrgs = [],
        MngIncidentReportFlag = false,
        MngCrisisReportFlag = false,
        TouDataFlag = false
    ) {
        this.UserPk = UserPk;
        this.UserId = UserId;
        this.MailAddress = MailAddress;
        this.IniPwdType = IniPwdType;
        this.IniPwdFree = IniPwdFree;
        this.NameKjLs = NameKjLs;
        this.NameKjFs = NameKjFs;
        this.NameKnLs = NameKnLs;
        this.NameKnFs = NameKnFs;
        this.CliFlag = CliFlag;
        this.RegistMethod = RegistMethod;
        this.AuthenticateMethod = AuthenticateMethod;
        this.LastLoginDt = LastLoginDt;
        this.SuspendFlag = SuspendFlag;
        this.UseStartDate = UseStartDate;
        this.UseEndDate = UseEndDate;
        this.MngSystemAdminFlag = MngSystemAdminFlag;
        this.MngServiceAdminFlag = MngServiceAdminFlag;
        this.MngHealthStaffFlag = MngHealthStaffFlag;
        this.MngHealthStaffOrgAll = MngHealthStaffOrgAll;
        this.MngHealthStaffOrgs = MngHealthStaffOrgs.map((item) => new MngHealthStaffOrgsForm(item.OrganizationPk, item.OrganizationId, item.OrganizationNmP));
        this.MngIncidentReportFlag = MngIncidentReportFlag;
        this.MngCrisisReportFlag = MngCrisisReportFlag;
        this.TouDataFlag = TouDataFlag;
    }
}

export class MngHealthStaffOrgsForm {
    constructor(OrganizationPk = '', OrganizationId = '', OrganizationNmP = '') {
        this.OrganizationPk = OrganizationPk;
        this.OrganizationId = OrganizationId;
        this.OrganizationNmP = OrganizationNmP;
    }
}
